import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import RequireRole from "@/components/RequireRole";
import ParentShell from "@/components/ParentShell";
import StudentShell from "@/components/StudentShell";
import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage, StudentLoginPage } from "@/pages/Auth";
import ParentDashboard from "@/pages/parent/Dashboard";
import ParentStudents from "@/pages/parent/Students";
import ParentTutors from "@/pages/parent/Tutors";
import ParentMaterial from "@/pages/parent/Material";
import PackReview from "@/pages/parent/PackReview";
import ParentCalendar from "@/pages/parent/Calendar";
import ParentRewards from "@/pages/parent/Rewards";
import ParentAssistant from "@/pages/parent/Assistant";
import StudentHome from "@/pages/student/Home";
import StudentProgress from "@/pages/student/Progress";
import StudentRewards from "@/pages/student/Rewards";
import StudentGames from "@/pages/student/Games";
import StudyMode from "@/pages/student/StudyMode";
import AdminPanel from "@/pages/admin/AdminPanel";
import OfflineNotice from "@/components/OfflineNotice";
import InvitationPage from "@/pages/Invitation";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <OfflineNotice />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/estudiante" element={<StudentLoginPage />} />
          <Route path="/invitacion/:token" element={<InvitationPage />} />

          <Route element={<RequireRole kinds={["parent"]} redirect="/login" />}>
            <Route path="/p" element={<ParentShell />}>
              <Route index element={<ParentDashboard />} />
              <Route path="estudiantes" element={<ParentStudents />} />
              <Route path="tutores" element={<ParentTutors />} />
              <Route path="material" element={<ParentMaterial />} />
              <Route path="material/:packId" element={<PackReview />} />
              <Route path="calendario" element={<ParentCalendar />} />
              <Route path="recompensas" element={<ParentRewards />} />
              <Route path="asistente" element={<ParentAssistant />} />
            </Route>
          </Route>

          <Route element={<RequireRole kinds={["student"]} redirect="/estudiante" />}>
            <Route path="/s/estudiar/:packId" element={<StudyMode />} />
            <Route path="/s" element={<StudentShell />}>
              <Route index element={<StudentHome />} />
              <Route path="progreso" element={<StudentProgress />} />
              <Route path="juegos" element={<StudentGames />} />
              <Route path="recompensas" element={<StudentRewards />} />
            </Route>
          </Route>

          <Route element={<RequireRole kinds={["platform_admin"]} redirect="/login" />}>
            <Route path="/admin" element={<AdminPanel />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
